import { AddSmimePropertiesRequest } from 'owa-smime/lib/utils/tryAddSmimeProperties';
import ComposeViewState from '../store/schema/ComposeViewState';
import { getFromAddress } from './getFromAddresses';
import Message from 'owa-service/lib/contract/Message';
import createSmimeDefaultViewState from 'owa-smime/lib/utils/createSmimeDefaultViewState';
import { getAllRecipients } from './getAllRecipientsAsEmailAddressStrings';

/**
 * Returns the AddSmimePropertiesRequestObject
 * @param viewState composeViewState of the current smime compose
 * @param message message object needs to sent to control
 * @param isSend true - if send, false - if save
 */
export default function getAddSmimePropertiesRequestObject(
    viewState: ComposeViewState,
    message: Message,
    isSend: boolean
): AddSmimePropertiesRequest {
    const smimeViewState = viewState.smimeViewState || createSmimeDefaultViewState();
    const {
        shouldSignMessageAsSmime,
        shouldEncryptMessageAsSmime,
        signingCertRawData,
    } = smimeViewState;
    return {
        shouldSignMessageAsSmime,
        shouldEncryptMessageAsSmime,
        message,
        fromAddress: getFromAddress(),
        isSend,
        composeId: viewState.composeId,
        signingCertRawData,
        attachments: viewState.attachmentWell.docViewAttachments,
        allRecipients: getAllRecipients(viewState),
    };
}
